export default function factory(options?: WorkerOptions | undefined): Worker {
    return new Worker(
        /* webpackChunkName: "playback.worker" */ new URL("./playback.worker.ts", import.meta.url),
        options,
    );
}
